import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.cryptoPayout.outline';

const LABELS = makeLabels(
  {
    CUSTOMER_EMAIL: ['customerEmail', 'Customer Email'],
    AMOUNT: ['amount', 'Payout total'],
    STATUS: ['status', 'Status'],
  },
  NAMESPACE,
);

export default LABELS;
